var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDsChatBubbleSmileIcon = function SvgDsChatBubbleSmileIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 56,
    height: 40,
    fill: "none",
    viewBox: "0 0 56 40"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#191A1C",
    fillRule: "evenodd",
    d: "M38.167 16a9.5 9.5 0 0 1 9.5 9.5 9.44 9.44 0 0 1-1.855 5.64c-.786 1.062-1.054 2.521-.54 3.86h-7.105a9.5 9.5 0 0 1 0-19m0-3c6.903 0 12.5 5.597 12.5 12.5 0 2.78-.908 5.348-2.443 7.423-.245.332-.29.775-.09 1.136l1.366 2.455A1 1 0 0 1 48.626 38h-10.46c-6.903 0-12.5-5.597-12.5-12.5S31.264 13 38.167 13",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#191A1C",
    fillRule: "evenodd",
    d: "M8.823 33.731a4.04 4.04 0 0 0-.335-4.414A15.25 15.25 0 0 1 5.333 20c0-8.468 6.865-15.333 15.333-15.333 5.714 0 10.699 3.126 13.336 7.76.924-.341 2.037-.65 3.031-.696C34.01 5.76 27.816 1.667 20.666 1.667 10.541 1.667 2.333 9.875 2.333 20a18.25 18.25 0 0 0 3.774 11.142c.251.327.294.772.094 1.132L3.66 36.848a1 1 0 0 0 .874 1.485h16.133a18.25 18.25 0 0 0 8.819-2.256 5.55 5.55 0 0 1-2.256-2.215 15.3 15.3 0 0 1-6.563 1.471H7.933z",
    clipRule: "evenodd"
  })));
};
export default SvgDsChatBubbleSmileIcon;